/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowUiCornerOutUpRightIcon16Light } from './ArrowUiCornerOutUpRightIcon16Light';
import { ArrowUiCornerOutUpRightIcon16Regular } from './ArrowUiCornerOutUpRightIcon16Regular';
import { ArrowUiCornerOutUpRightIcon16Solid } from './ArrowUiCornerOutUpRightIcon16Solid';
import { ArrowUiCornerOutUpRightIcon20Light } from './ArrowUiCornerOutUpRightIcon20Light';
import { ArrowUiCornerOutUpRightIcon20Regular } from './ArrowUiCornerOutUpRightIcon20Regular';
import { ArrowUiCornerOutUpRightIcon20Solid } from './ArrowUiCornerOutUpRightIcon20Solid';
import { ArrowUiCornerOutUpRightIcon24Regular } from './ArrowUiCornerOutUpRightIcon24Regular';
import { ArrowUiCornerOutUpRightIcon24Solid } from './ArrowUiCornerOutUpRightIcon24Solid';
import { ArrowUiCornerOutUpRightIcon32Regular } from './ArrowUiCornerOutUpRightIcon32Regular';
import { ArrowUiCornerOutUpRightIcon64Regular } from './ArrowUiCornerOutUpRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowUiCornerOutUpRightIcon16Light,
        regular: ArrowUiCornerOutUpRightIcon16Regular,
        solid: ArrowUiCornerOutUpRightIcon16Solid,
    },
    20: {
        light: ArrowUiCornerOutUpRightIcon20Light,
        regular: ArrowUiCornerOutUpRightIcon20Regular,
        solid: ArrowUiCornerOutUpRightIcon20Solid,
    },
    24: {
        regular: ArrowUiCornerOutUpRightIcon24Regular,
        solid: ArrowUiCornerOutUpRightIcon24Solid,
    },
    32: {
        regular: ArrowUiCornerOutUpRightIcon32Regular,
    },
    64: {
        regular: ArrowUiCornerOutUpRightIcon64Regular,
    },
};
export var ArrowUiCornerOutUpRightIcon = forwardRef('ArrowUiCornerOutUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
